/**
 * The plain-string value of a text prop, for the places that need text rather
 * than nodes: `alt`, `aria-label`, `title`.
 *
 * Inline-editable props hold a React element while the editor is open (the
 * contentEditable span it injects), and an element in an attribute renders as
 * garbage — which is why those props used to be barred from inline editing
 * altogether. Coercing at the attribute instead keeps the prop editable and
 * costs only an empty fallback inside the editor; published pages always have
 * the real string.
 */
export function plainText(value: unknown): string {
  return typeof value === "string" ? value : "";
}
